var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5072 1.60444C14.6019 3.69918 14.6456 7.06814 12.6382 9.21607L12.5072 9.35144L7.07206 14.7866C5.45431 16.4045 2.83098 16.4045 1.21339 14.7866C-0.362964 13.2102 -0.403414 10.6797 1.09213 9.05412L1.21339 8.92775L6.54649 3.59464C7.65706 2.48408 9.45761 2.48408 10.5681 3.59464C11.6426 4.66936 11.6773 6.39024 10.6719 7.50652L10.5681 7.61615L6.17891 12.0053C5.8998 12.2842 5.44748 12.2842 5.16838 12.0053C4.91082 11.7477 4.89098 11.3424 5.10899 11.062L5.16838 10.9948L9.55752 6.60561C10.11 6.05329 10.11 5.15751 9.55752 4.60515C9.03263 4.08025 8.19811 4.05406 7.64237 4.52638L7.55693 4.60515L2.22383 9.93825C1.16399 10.9981 1.16399 12.7163 2.22383 13.7762C3.24817 14.8005 4.88792 14.8348 5.95335 13.8785L6.06158 13.7762L11.4967 8.34106C13.0779 6.75975 13.0779 4.19605 11.4967 2.61497C9.95604 1.0743 7.48269 1.03473 5.89407 2.49635L5.77064 2.61497L1.27948 7.10613C1.00037 7.38508 0.548046 7.38508 0.268946 7.10613C0.0113894 6.84858 -0.00845813 6.44325 0.209558 6.16288L0.268946 6.09559L4.76011 1.60443C6.8995 -0.534809 10.3679 -0.534809 12.5071 1.60443L12.5072 1.60444Z",
    fill: "#8375E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.ca75433f07b23795f4f147bf450df325.svg";
export { ForwardRef as ReactComponent };